import { SET_ROUTER_LOADER } from '@/store/mutation_types';
import { CLEAR_ROUTER_LOADER, UPDATE_ROUTER_LOADER } from '@/store/action_types';

// Whether a guarded navigation is in flight. The route guard and the API
// error handler dispatch these actions; this module is what receives them.
const routerLoader = {
  state: {
    routerIsLoading: false,
  },
  getters: {
    routerIsLoading: (state: { routerIsLoading: boolean }) => state.routerIsLoading,
  },
  mutations: {
    [SET_ROUTER_LOADER]: (state: { routerIsLoading: boolean }, payload: boolean) => {
      state.routerIsLoading = payload;
    },
  },
  actions: {
    [UPDATE_ROUTER_LOADER]: ({ commit }: any, payload: boolean) => {
      commit(SET_ROUTER_LOADER, Boolean(payload));
    },
    [CLEAR_ROUTER_LOADER]: ({ commit }: any) => {
      commit(SET_ROUTER_LOADER, false);
    },
  },
};

export default routerLoader;
